import React, { useEffect, useState, useRef, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextareaAutosize,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Select,
  TableRow,
  Paper,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Chip,
  FormControl,
  InputLabel,
  CircularProgress,
  Backdrop,
  Stack,
} from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector, useDispatch } from "react-redux";
import { diff } from "deep-diff";
import CollapseSection from "../../../components/ui/CollapseSection";
import "./Modification.css";
import RowModification from "./RowModification";
//import ConsumptionRatio from "../../Dashboard/ConsumptionRatio";
import {
  GetScenarios,
  SubmitModification,
  setState,
  ExportExcel,
  UnblockFullOrderMSQ,
  ImportExcel,
  DownloadFile,
  addFile,
  deleteFile,
  Upload,
  reset,
  deleteExistingFile,
  RecallModification
} from "../reviewSlice";
import _ from "lodash";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import AttachmentIcon from "@mui/icons-material/Attachment";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { green, orange, red, grey, blue } from "@mui/material/colors";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import EditIcon from "@mui/icons-material/Edit";

const Modification = (props) => {

  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchProduct, setSearchProduct] = useState("");
  //const [pageSize, setPageSize] = React.useState(20);
  const [rows, setRows] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [isDisplayBlockedCustomers, setIsDisplayBlockedCustomers] =
    useState(false);
  const theme = useTheme();
  const [selectedWeeklyData, setSelectedWeeklyData] = useState([]);
  //const [oldWeeklyData, setOldWeeklyData] = useState({});
  //const [newWeeklyData, setNewWeeklyData] = useState({});
  //const [totalQuota, setTotalQuota] = useState(0);
  //const [revisedQuota, setRevisedQuota] = useState(0);
  //const [difference, setDifference] = useState(0);
  const [modificationPercentage, setModificationPercentage] = useState("");
  const [isOnlySelectedCustomers, setIsOnlySelectedCustomers] = useState(false);
  const modPercFunc = useRef();
  const rounderFunc = useRef();
  const pullForwardFunc = useRef();
  const ModRef = useRef(null);
  const fileSectionRef = useRef(null);
  const [rounder, setRounder] = useState("");
  const [isCheckedHeader, setIsCheckedHeader] = useState({
    isCheckedWeekly1: false,
    isCheckedWeekly2: false,
    isCheckedWeekly3: false,
    isCheckedWeekly4: false,
    isCheckedWeekly5: false,
  });
  const [currentWeek, setCurrentWeek] = useState(0);
  const [biweeklyHalf, setBiweeklyHalf] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const setIsCollapseOpened = props.setIsCollapseOpened;
  const [rowHeight, setrowHeight] = useState(180);

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
  //const [displayFileButtons, setDisplayFileButtons] = useState(false);

  const [updatedRowIds, setUpdatedRowIds] = useState([]);
  const [weeklyPullForward, setWeeklyPullForward] = useState([]);

  const selectInitialValues = [
    "New Final Quota",
    "Delta Modifications",
    "Last Approved Modification",
    "Initial Quota",
  ];

  const [selectedValues, setSelectedValues] = useState(selectInitialValues);
  const [uploadedFile, setUploadedFile] = useState(null);
  const hiddenFileInput = useRef(null);
  const [excelCustomerIds, setExcelCustomerIds] = useState([]);
  const [mainComments, setMainComments] = useState("");
  const [userComments, setUserComments] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null); // Track the selected row
  const [commentData, setCommentData] = useState([]);
  const inputRef = useRef(null);

  const [selectedHeaders, setSelectedHeaders] = useState([]);
  const dispatch = useDispatch();

  const review = useSelector((state) => state.review);
  const {
    selectedPeriod,
    selectedCountry,
    selectedCountryID,
    selectedScenario,
    selectedScenarioID,
    getQuotaDetails,
    currentSelectedScenario,
    getWeekStatus,
    quotaConsumptionTableState,
    checkedCustomersList,
    updatedWeeklyData,
    isLoading,
    excelData,
    modifyList,
    CustomerSearchTxt,
    ProductSearchTxt,
    isDisplayBlocked,
    ModifiedList,
    files,
    displayModification,
    clearMTable,
    selectedOrderStatus,
    searchTxt,
    onUnblockClicked,
    customerListForDecisionSubmission,
    selectedCustomersForDecision,
    isCurrentWeekRowChanged,
    modificationId,
    getScenarios,
    onMSQClicked,
    onUnblockClickedSubmitted,
    isModifyClicked,
    isRecallClicked,
    RecallList,
    canModifyRecall,
    countries,
    displayFileButtons,
    selectedQuotaID
  } = review;
  const apiRef = useGridApiRef();

  const handleHeaderChecked = (e) => {
    setIsCheckedHeader((prev) => {
      return { ...isCheckedHeader, [e.target.name]: e.target.checked };
    });
  };

  useEffect(() => {
    if (displayFileButtons && fileSectionRef.current) {
      fileSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [displayFileButtons]);

  useEffect(() => {
    dispatch(
      setState("updatedWeeklyData", ModifiedList?.quotaCusumptionCustomers)
    );
    if (searchProduct === undefined) setSearchProduct("");
    if (searchCustomer === undefined) setSearchCustomer("");
    if (isOnlySelectedCustomers) {
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          if (rowSelectionModel !== undefined) {
            retVal = rowSelectionModel.includes(item.customerQuotaID);
          } else {
            return retVal;
          }
          return retVal;
        });
        return val;
      });
    } else if (isDisplayBlocked) {
      filterSetRow(ModifiedList?.quotaCusumptionCustomers);
    } else {
      setRows(ModifiedList.quotaCusumptionCustomers);
    }
    if (isModifyClicked) {
      scrollToThirdDataGrid();
    }
  }, [ModifiedList]);

  useEffect(()=>{
    if(selectedValues.length > 0){
      setrowHeight(45* selectedValues.length);
    }
  },[selectedValues])

  useEffect(() => {
    if (clearMTable) {
      setIsCheckedHeader({
        isCheckedWeekly1: false,
        isCheckedWeekly2: false,
        isCheckedWeekly3: false,
        isCheckedWeekly4: false,
        isCheckedWeekly5: false,
      });
      setUpdatedRowIds([]);
      setModificationPercentage("");
      setRounder("");
      setUserComments({});
      dispatch(setState("clearMTable", false));
    }
  }, [clearMTable]);

  const scrollToThirdDataGrid = () => {
    setTimeout(() => {
      if (ModRef.current) {
        ModRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000);
  };

  useEffect(() => {
    if (getWeekStatus.chkFirstHalf) {
      setBiweeklyHalf(1);
    } else if (getWeekStatus.chkSecondHalf) {
      setBiweeklyHalf(2);
    } else {
      setBiweeklyHalf(0);
    }

    if (getWeekStatus.chkMonth) {
      if (getWeekStatus.chkWeek1) {
        setCurrentWeek(1);
      } else if (getWeekStatus.chkWeek2) {
        setCurrentWeek(2);
      } else if (getWeekStatus.chkWeek3) {
        setCurrentWeek(3);
      } else if (getWeekStatus.chkWeek4) {
        setCurrentWeek(4);
      } else if (getWeekStatus.chkWeek5) {
        setCurrentWeek(5);
      }
    } else {
      setCurrentWeek(0);
    }
    if (isModifyClicked) {
      scrollToThirdDataGrid();
    }
  }, [getWeekStatus, ModifiedList]);

  const updatedCustomerDepletionModels = (updatedWeeklyData ?? []).map((row) =>
    (row?.depletionModel ?? row?.DepletionModel ?? "").trim().toLowerCase()
  );
  const hasAnyNoneDepletion = updatedCustomerDepletionModels.some(
    (m) => m === "none"
  );
  const hasAnyBiweeklyDepletion = updatedCustomerDepletionModels.some(
    (m) => m === "biweekly"
  );
  const allRowsNoneDepletion =
    updatedCustomerDepletionModels.length > 0 &&
    updatedCustomerDepletionModels.every((m) => m === "none");
  const allRowsBiweeklyDepletion =
    updatedCustomerDepletionModels.length > 0 &&
    updatedCustomerDepletionModels.every((m) => m === "biweekly");
  const isWeek1HeaderCheckboxDisabled = hasAnyNoneDepletion
    ? false
    : hasAnyBiweeklyDepletion
      ? !getWeekStatus.chkFirstHalf
      : !getWeekStatus.chkWeek1;
  const isWeek2HeaderCheckboxDisabled = hasAnyBiweeklyDepletion
    ? false
    : !getWeekStatus.chkWeek2;

  const w = 95;
  const noDepletionColumns = [
    {
      field: "weekly1",
      headerName: "Final Quota",
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
              <span
                style={{
                  fontWeight: "500",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                Final<br></br>Quota
              </span>
          }
          control={
            <Checkbox
              checked={isCheckedHeader.isCheckedWeekly1}
              name="isCheckedWeekly1"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly1"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    }
  ]
  const biweeklyColumns = [
    {
      field: "weekly1",
      headerName: "First Half",
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
              <span
                style={{
                  fontWeight: "500",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                First<br></br>Half
              </span>
          }
          control={
            <Checkbox
              disabled={!getWeekStatus.chkFirstHalf}
              checked={isCheckedHeader.isCheckedWeekly1}
              name="isCheckedWeekly1"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly1"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },
    {
      field: "weekly2",
      headerName: "Week2",
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
              <span
                style={{
                  fontWeight: "500",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                Second<br></br>Half
              </span>
          }
          control={
            <Checkbox
              checked={isCheckedHeader.isCheckedWeekly2}
              name="isCheckedWeekly2"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly2"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },
  ]
  const weeklyColumns = [
    {
      field: "weekly1",
      headerName: "Week1",
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
              <span
                style={{
                  fontWeight: "500",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "MontSerrat, Sans-serif",
                }}
              >
                Week1
              </span>
          }
          control={
            <Checkbox
              disabled={isWeek1HeaderCheckboxDisabled}
              checked={isCheckedHeader.isCheckedWeekly1}
              name="isCheckedWeekly1"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly1"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly2",
      headerName: "Week2",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek2,
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
              <span
                style={{
                  fontWeight: "500",
                  color: "black",
                  fontSize: "15px",
                  fontFamily: "Montserrat, Sans-serif",
                }}
              >
                Week2
              </span>
          }
          control={
            <Checkbox
              disabled={isWeek2HeaderCheckboxDisabled}
              checked={isCheckedHeader.isCheckedWeekly2}
              name="isCheckedWeekly2"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly2"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly3",
      headerName: "Week3",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek3,
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
            <span
              style={{
                fontWeight: "500",
                color: "black",
                fontSize: "15px",
                fontFamily: "Montserrat, Sans-serif",
              }}
            >
              Week3
            </span>
          }
          control={
            <Checkbox
              disabled={!getWeekStatus.chkWeek3}
              checked={isCheckedHeader.isCheckedWeekly3}
              name="isCheckedWeekly3"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly3"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly4",
      headerName: "Week4",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek4,
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
            <span
              style={{
                fontWeight: "500",
                color: "black",
                fontSize: "15px",
                fontFamily: "Montserrat, Sans-serif",
              }}
            >
              Week4
            </span>
          }
          control={
            <Checkbox
              disabled={!getWeekStatus.chkWeek4}
              checked={isCheckedHeader.isCheckedWeekly4}
              name="isCheckedWeekly4"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly4"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },

    {
      field: "weekly5",
      headerName: "Week5",
      //editable: getWeekStatus.chkMonth && getWeekStatus.chkWeek5,
      flex: 1,
      minWidth: 135,
      align: "center",
      headerAlign: "center",
      renderHeader: () => (
        <FormControlLabel
          label={
            <span
              style={{
                fontWeight: "500",
                color: "black",
                fontSize: "15px",
                fontFamily: "Montserrat, Sans-serif",
              }}
            >
              Week5
            </span>
          }
          control={
            <Checkbox
              disabled={!getWeekStatus.chkWeek5}
              checked={isCheckedHeader.isCheckedWeekly5}
              name="isCheckedWeekly5"
              onClick={(e)=>e.stopPropagation()}
              onChange={(e) => handleHeaderChecked(e)}
            />
          }
        />
      ),
      renderCell: (params) => {
        return (
          <RowModification
            params={params}
            type={"weekly5"}
            selectedValues={selectedValues}
            getUpdatedRowIds={getUpdatedRowIds}
            weeklyPullForward={weeklyPullForward}
            rowSelectionModel={rowSelectionModel}
            isCheckedHeader={isCheckedHeader}
            modificationPercentage={modificationPercentage}
            rounder={rounder}
            updatedWeeklyData={updatedWeeklyData}
            modPercFunc={modPercFunc}
            rounderFunc={rounderFunc}
            currentWeek={currentWeek}
            biweeklyHalf={biweeklyHalf}
          />
        );
      },
      sortComparator: (v1, v2) => v1 - v2,
    },
  ]
  const columns = [
    {
      field: "customerName",
      headerName: "Customer / CG",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "sapCustomerNumber",
      headerName: "Customer Number",
      flex: 1,
      minWidth: 90,
    },
    {
      field: "skuName",
      headerName: "SKU",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "skuNumb",
      headerName: "SKU Number",
      flex: 1,
      minWidth: 90,
    },
    {
      field: "depletionModelName",
      headerName: "Depletion Type",
      flex: 1,
      minWidth: 140,
      align: "left",
      headerAlign: "center",
      valueGetter: (valueOrParams, rowMaybe) => {
        const row =
          rowMaybe ??
          (valueOrParams &&
          typeof valueOrParams === "object" &&
          "row" in valueOrParams
            ? valueOrParams.row
            : null);
        if (!row) return "";
        return row.depletionModelName ?? row.DepletionModelName ?? "";
      },
      sortComparator: (v1, v2) =>
        String(v1 ?? "").localeCompare(String(v2 ?? ""), undefined, {
          sensitivity: "base",
          numeric: true,
        }),
    },
    {
      field: "sit",
      headerName: "SIT",
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      }
    },
    {
      field: "unusedQuota",
      headerName: "Unused Quota",
      width: 90,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      }
    },
    {
      field: "quota",
      headerName: "Quota",
      flex: 1,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      }
    },
    {
      field: "efs",
      headerName: "EFS",
      flex: 1,
      minWidth: 70,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        const formattedValue = params.value?.toLocaleString('en-US');
        return formattedValue;
      }
    },
    {
      field: "availableQuota",
      headerName: "Available Quota",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
      valueGetter: (params) => {
        const idx = updatedWeeklyData.findIndex(
          (item) => item.customerQuotaID === params.row.customerQuotaID
        );
        if (idx <= -1) return 0;

        const row = updatedWeeklyData[idx];
        const depletionModel = (row?.depletionModel ?? "")
          .trim()
          .toLowerCase();
        const isFourWeekPeriod = (
          ModifiedList?.depletionPeriodType ??
          ""
        )
          .trim()
          .toLowerCase()
          .includes("4-week");
        const quota = row.newFinalQuota;
        const efs = row.efs ?? 0;

        let weekValue = 0;
        if (depletionModel === "none") {
          weekValue = quota.weekly1 ?? 0;
        } else if (depletionModel === "biweekly") {
          weekValue =
            biweeklyHalf === 1 ? quota.weekly1 ?? 0 : quota.weekly2 ?? 0;
        } else if (currentWeek === 1) {
          weekValue = quota.weekly1 ?? 0;
        } else if (currentWeek === 2) {
          weekValue = quota.weekly2 ?? 0;
        } else if (currentWeek === 3) {
          weekValue = quota.weekly3 ?? 0;
        } else if (currentWeek === 4) {
          weekValue = quota.weekly4 ?? 0;
        } else if (isFourWeekPeriod) {
          weekValue = quota.weekly4 ?? 0;
        } else {
          weekValue = quota.weekly5 ?? 0;
        }

        return weekValue - efs;
      },
      cellClassName: "lightblue-background",
      headerClassName: "lightblue-background-header"
    },
    {
      field: "rowInfo",
      headerName: "Row",
      flex: 1,
      minWidth: 210,
      maxWidth:220,
      renderCell: (params) => {
        const style = {
          p: 0,
          width: "100%",
          maxWidth: "100%",
          "& .MuiTypography-root":{
            fontFamily:"museo-sans,sans-serif !important",
            fontSize: "0.875rem !important",
          }
        };
        return (
          // <Grid container row-direction="column">
          <List sx={style}>
            <div>
              {selectedValues.includes("New Final Quota") && (
                <ListItem>
                  <ListItemText primary={params.row.newFinalQuota.row} />
                </ListItem>
              )}
              {selectedValues.includes("Delta Modifications") && (
                <ListItem>
                  <ListItemText primary={params.row.deltaModification.row} />
                </ListItem>
              )}
              {selectedValues.includes("Last Approved Modification") && (
                <ListItem>
                  <ListItemText primary={params.row.lastApproved.row} />
                </ListItem>
              )}
              {selectedValues.includes("Initial Quota") && (
                <ListItem>
                  <ListItemText primary={params.row.initialQuota.row} />
                </ListItem>
              )}
            </div>
          </List>
        );
      },
    },
  ];

  const ModifyWeeklyValues = (props) => {
    let params = props.params;
    let styles = props.styles;
    let type = props.type;

    return (
      <TextField
        sx={{ maxWidth: "100px" }}
        type="text"
        value={params.row[`${type}`]}
        name={type}
        className={styles}
      />
    );
  };

  function getChipProps(params) {
    if (params.value === "Low") {
      return {
        label: "Low",
        style: {
          fontWeight: "bold",
          borderColor: red[500],
          backgroundColor: red[50],
          color: red[500],
        },
      };
    } else if (params.value === "Medium") {
      return {
        label: "Medium",
        style: {
          fontWeight: "bold",
          borderColor: orange[500],
          backgroundColor: orange[50],
          color: orange[500],
        },
      };
    } else if (params.value === "High") {
      return {
        label: "High",
        style: {
          fontWeight: "bold",
          borderColor: green[500],
          backgroundColor: green[50],
          color: green[500],
        },
      };
    } else {
      return {
        label: "Other",
        style: {
          fontWeight: "bold",
          borderColor: blue[500],
          backgroundColor: blue[50],
          color: blue[500],
        },
      };
    }
  }


  const DisplayComments = (params) => {
    const [displayComments, setDisplayComments] = useState(params.comments);
    const [userCommentsLocal, setUserCommentsLocal] = useState("");
    const [open, setOpen] = useState(false);
    const rowId = params.params.row.customerQuotaID;
    const color =
      params.comments.length > 0 &&
        params.comments != "Default Customer quota record"
        ? "#891515"
        : "black";

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const handleConfirm = () => {
      setDisplayComments(userCommentsLocal);
      const updatedComments = { ...userComments, [rowId]: userCommentsLocal };
      setUserComments(updatedComments);
      let currentState = _.cloneDeep(updatedWeeklyData);
      const updatedArray = currentState.map((item) => ({
        ...item,
        customerComments:
          updatedComments[item.customerQuotaID] || item.customerComments,
      }));
      setCommentData(updatedArray);
      dispatch(setState("updatedWeeklyData", updatedArray));
      let selectedCQID = rows.map(x => x.customerQuotaID);
      //console.log(rows);
      setRows(updatedArray.filter((row) => selectedCQID.includes(row.customerQuotaID)));
      //setUserComments()
      setOpen(false);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const handleEditClick = (rowId) => {
      setSelectedRowId(rowId);
      setOpen(true);
    };

    const handleComments = (e) => {
      setUserCommentsLocal(e.target.value);
    };

    return (
      <div>
        <>
          <IconButton
            onClick={() => setOpen(true)}
            title={
              userComments[rowId]
                ? userComments[rowId]
                : params.params.row.customerComments
            }
          >
            {params.comments || userComments[rowId] ? (
              <ForumOutlinedIcon
                title={
                  userComments[rowId] ? userComments[rowId] : params.comments
                }
                sx={{ color: "#891515" }}
              />
            ) : (
              <ForumOutlinedIcon />
            )}
          </IconButton>

          <Dialog
            //disableEnforceFocus
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
          //aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <TextareaAutosize
                  //onChange={(event) => setUserComments(event.target.value)}
                  onChange={handleComments}
                  aria-label="minimum height"
                  minRows={5}
                  //readOnly
                  placeholder="Comments"
                  style={{ width: 500, fontSize: 18 }}
                  defaultValue={
                    userComments[rowId]
                      ? userComments[rowId]
                      : params.params.row.customerComments
                  }
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                size="small"
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkred.main",
                  },

                }}
              >
                Cancel
              </Button>
              <Button
                autoFocus
                onClick={handleConfirm}
                size="small"
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkred.main",
                  },

                }}
              >
                Save Changes
              </Button>
            </DialogActions>
          </Dialog>
        </>
      </div>
    );
  };

  useEffect(() => {
    if (userComments !== null || userComments !== undefined) {
      const keysArray = Object.keys(userComments).map(Number);
      setRowSelectionModel(keysArray);
      keysArray.forEach((item) => getUpdatedRowIds(item));
      //console.log(updatedArray);
    }
  }, [userComments]);

  const handleSearchCustomer = (e) => {
    const value = e.target.value;
    setSearchCustomer(value);
  };

  const handleSearchProduct = (e) => {
    const value = e.target.value;
    setSearchProduct(value);
  };

  const handleSelectChange = (event) => {
    const { value } = event.target;
    setSelectedValues(value);
  };

  //console.log(selectedValues);

  const handleSelectDelete = (value) => () => {
    //console.log(value);
    setSelectedValues((selectedValues) =>
      selectedValues.filter((selected) => selected !== value)
    );
  };

  const handleChooseFile = () => {
    //setDisplayFileButtons((prevShow) => !prevShow);
    dispatch(setState("displayFileButtons",!displayFileButtons));
  };

  const getUpdatedRowIds = (id) => {
    setUpdatedRowIds((updatedRowIds) => [...updatedRowIds, id]);
  };

  const handleSubmit = () => {
    let isValid = IsValid();
    if (isValid === true) {
      dispatch(Upload({ method: "POST" })).then(() => {
        if (onUnblockClicked || onMSQClicked) {
          dispatch(setState("onUnblockClickedSubmitted", true));
        }
        handleSubmitModification();
      });
    }
  };

  const handleSubmitModification = () => {
    let userData = JSON.parse(localStorage.getItem("data"));
    userData["token"] = "";
    userData["userCountries"] = null;
    userData["userCustomerTypes"] = null;

    let onlyUpdatedData = [];
    updatedWeeklyData.forEach((data) => {
      const newData = data.newFinalQuota;
      const previousData = data.lastApproved;
      const dataChanged = ['weekly1', 'weekly2', 'weekly3', 'weekly4', 'weekly5'].some(
        (key) => previousData[key] !== newData[key]
      );

      if (dataChanged) {
        onlyUpdatedData.push(data);
      }
    });
    const weeklyUpdatedObj = onlyUpdatedData.map((row) => {
      return weeklyUpdatedData(row);
    });

    if (weeklyUpdatedObj.length === 0) {
      showMessage("No changes made to the records", "info");
      return;
    }

    //console.log(weeklyUpdatedObj);
    let geoId = countries.find((country) => country.countryName === ModifiedList?.geoName)?.countryID;

    let modificationObj = {
      approvedRejectedBy: ModifiedList?.approvedRejectedBy,
      comments: mainComments,
      commentsNew: mainComments, //send through this
      countryid: geoId,
      countryName: ModifiedList?.geoName,
      depletionModel: ModifiedList?.depletionModel,
      isFullOrder: onUnblockClicked,
      isModified: ModifiedList?.isModified,
      isStickToQuota: onMSQClicked,
      modificationID: ModifiedList?.modificationID,
      orderStatus: "Blocked",
      quotaCusumptionCustomers: [],
      quotaCusumptionCustomers2: weeklyUpdatedObj,
      quotaID: ModifiedList?.quotaID,
      quotaModificationFiles: ModifiedList.quotaModificationFiles,
      rejectionComments: ModifiedList?.rejectionComments,
      scenarioID: selectedScenarioID,
      scenarioName: selectedScenario,
      sentToSAPFlag: ModifiedList?.sentToSAPFlag,
      status: ModifiedList?.status,
      updateDate: ModifiedList?.updateDate,
      updatedBy: ModifiedList?.updatedBy,
      user: userData,
      modificationDeviationPercentage: ModifiedList?.modificationDeviationPercentage,
      originalTotalForecast : ModifiedList?.originalTotalForecast,
      revisedQuota: modifiedQuotaCM
    };

    //console.log("modificationObj",modificationObj);
    dispatch(SubmitModification(modificationObj)).then(() => {
      dispatch(reset("clear"));
      const obj = {
        countryID: selectedCountryID,
        orderStatus: "All",
        searchText: searchTxt,
        period: selectedPeriod,
      };
      dispatch(GetScenarios(obj));
      dispatch(setState("clearMTable", true));
      dispatch(setState("clearReviewTable", true));
    });
  };


  useEffect(() => {
    if (checkedCustomersList?.length > 0) {
      if (isModifyClicked) {
        setRowSelectionModel(checkedCustomersList);
        dispatch(setState("isModifyClicked", false));
        setIsOnlySelectedCustomers(false);
      }
    }
  }, [rows]);

  useEffect(() => {
    setIsOnlySelectedCustomers(false);
    if (checkedCustomersList?.length > 0) {
      setRowSelectionModel(checkedCustomersList);
      setUpdatedRowIds([]);
    } else {
      setRowSelectionModel([]);
      setUpdatedRowIds([]);
    }
    if (isModifyClicked) {
      dispatch(setState("isModifyClicked", false));
      if (searchProduct === undefined) setSearchProduct("");
      if (searchCustomer === undefined) setSearchCustomer("");
      //setRows(modifyList);
      if (isOnlySelectedCustomers) {
        setRows((prevVal) => {
          let val = modifyList?.filter((item) => {
            let retVal = false;
            if (rowSelectionModel !== undefined) {
              retVal = rowSelectionModel.includes(item.customerQuotaID);
            } else {
              return retVal;
            }
            return retVal;
          });
          return val;
        });
      } else if (isDisplayBlocked) {
        filterSetRow(modifyList);
      } else {
        setRows(modifyList);
      }
      setSearchCustomer(CustomerSearchTxt);
      setSearchProduct(ProductSearchTxt);
      scrollToThirdDataGrid();
    }
  }, [isModifyClicked]);

  useEffect(() => {
    if (modifyList?.length > 0) {
      if (searchProduct === undefined) setSearchProduct("");
      if (searchCustomer === undefined) setSearchCustomer("");
      //setRows(modifyList);
      if (isOnlySelectedCustomers) {
        setRows((prevVal) => {
          let val = modifyList?.filter((item) => {
            let retVal = false;
            if (rowSelectionModel !== undefined) {
              retVal = rowSelectionModel.includes(item.customerQuotaID);
            } else {
              return retVal;
            }
            return retVal;
          });
          return val;
        });
      } else if (isDisplayBlocked) {
          filterSetRow(modifyList);
      } else {
        setRows(modifyList);
      }
      setSearchCustomer(CustomerSearchTxt);
      setSearchProduct(ProductSearchTxt);
      setIsDisplayBlockedCustomers(isDisplayBlocked);
    }
    if (isModifyClicked) {
      scrollToThirdDataGrid();
    }
  }, [modifyList]);

  const filterSetRow = (List) =>{
    setRows((prevVal) => {
      let val = List?.filter((item) => {
        let retVal = false;
        retVal =  item.orderStatus.toLowerCase().includes("blocked")  &&
        (item.customerName
          .toLowerCase()
          .includes(searchCustomer.toLowerCase()) ||
          item.sapCustomerNumber
            .toLowerCase()
            .includes(searchCustomer.toLowerCase())) &&
        (item.skuName
          .toLowerCase()
          .includes(searchProduct?.toLowerCase()) ||
          item.skuNumb
            .toLowerCase()
            .includes(searchProduct?.toLowerCase()));
        return retVal;
      });
      return val;
    });
  }

  //console.log(quotaConsumptionTableState);

  useEffect(() => {
    let upRow = [...new Set([...rowSelectionModel, ...updatedRowIds])];
    setRowSelectionModel(upRow);
    //IsValidIntendedQuantity();
  }, [updatedWeeklyData]);
  useEffect(() => {
    if ((onUnblockClicked || onMSQClicked) && isCurrentWeekRowChanged) {
      setUnblockMSQDecision();
    }
  }, [isCurrentWeekRowChanged]);
  const setUnblockMSQDecision = () => {
    if (customerListForDecisionSubmission?.length > 0) {
      let customerList = [];
      let customerListDecision = JSON.parse(
        JSON.stringify(customerListForDecisionSubmission)
      );
      for (let i = 0; i < selectedCustomersForDecision.length; i++) {
        const row = ModifiedList.quotaCusumptionCustomers.find(
          (row) => row.customerQuotaID === selectedCustomersForDecision[i]
        );
        if (row["orderStatus"].toLowerCase() == "blocked") {
          customerList.push(row.customerQuotaID);
        }
      }
      let quotaDetailslist = JSON.parse(JSON.stringify(ModifiedList));
      quotaDetailslist.quotaCusumptionCustomers = JSON.parse(
        JSON.stringify(updatedWeeklyData)
      );
      let idxs = -1;
      for (let i = 0; i < customerList.length; i++) {
        let details = {};
        for (let j = 0; j < customerListForDecisionSubmission.length; j++) {
          let Ind = customerListForDecisionSubmission[j].details.findIndex(
            (x) => Number(x.customerQuotaId) === Number(customerList[i])
          );
          if (Ind > -1) {
            details = customerListForDecisionSubmission[j].details[Ind];
            idxs = j;
            break;
          }
        }
        let packSize = Number(details.packSize);
        let idx = quotaDetailslist.quotaCusumptionCustomers.findIndex(
          (x) => x.customerQuotaID === Number(customerList[i])
        );
        let quota = 0;
        if (currentWeek === 1)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly1;
        if (currentWeek === 2)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly2;
        if (currentWeek === 3)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly3;
        if (currentWeek === 4)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly4;
        if (currentWeek === 5)
          quota =
            quotaDetailslist.quotaCusumptionCustomers[idx].newFinalQuota
              .weekly5;

        let availableQuota =
          quota - quotaDetailslist.quotaCusumptionCustomers[idx].consumption;
        quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM = availableQuota;
        let packConversion = Math.round(availableQuota / packSize);
        let detailedOrders = customerListDecision[idxs].details.filter(
          (x) => Number(x.customerQuotaId) === Number(customerList[i])
        );
        for (let i = 0; i < detailedOrders.length; i++) {
          let Ratio =
            Number(detailedOrders[i].intendedQtyUoM) /
            (quotaDetailslist.quotaCusumptionCustomers[idx].intendedQuantity +
              quotaDetailslist.quotaCusumptionCustomers[idx].consumption);
          detailedOrders[i].modifiedQtyUoM = Math.round(quotaDetailslist.quotaCusumptionCustomers[idx].modifiedOrderQtyUoM * Ratio);
          detailedOrders[i].modifiedQtyPacks = Math.round(detailedOrders[i].modifiedQtyUoM / packSize);
        }
      }
      dispatch(setState("ModifiedList", quotaDetailslist));
      if (searchProduct === undefined) setSearchProduct("");
      if (searchCustomer === undefined) setSearchCustomer("");
      if (isOnlySelectedCustomers) {
        setRows((prevVal) => {
          let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
            let retVal = false;
            if (rowSelectionModel !== undefined) {
              retVal = rowSelectionModel.includes(item.customerQuotaID) &&
                (item.customerName
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase()) ||
                  item.sapCustomerNumber
                    .toLowerCase()
                    .includes(searchCustomer.toLowerCase())) &&
                (item.skuName
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()) ||
                  item.skuNumb
                    .toLowerCase()
                    .includes(searchProduct?.toLowerCase()));
            } else {
              return retVal;
            }
            return retVal;
          });
          return val;
        });
      } else if (isDisplayBlockedCustomers) {
        setRows((prevVal) => {
          let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
            let retVal = false;
            retVal = item.orderStatus.toLowerCase().includes("blocked") &&
              (item.customerName
                .toLowerCase()
                .includes(searchCustomer.toLowerCase()) ||
                item.sapCustomerNumber
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase())) &&
              (item.skuName
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()) ||
                item.skuNumb
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()));
            return retVal;
          });
          return val;
        });
      }
      else {
        setRows(ModifiedList.quotaCusumptionCustomers);
      }
      dispatch(
        setState(
          "updatedWeeklyData",
          quotaDetailslist?.quotaCusumptionCustomers
        )
      );
      dispatch(setState("isCurrentWeekRowChanged", false));
      dispatch(
        setState("customerListForDecisionSubmission", customerListDecision)
      );
    }
  };

  const IsValid = () => {
    const isFourWeekPeriod = (
      ModifiedList?.depletionPeriodType ?? ""
    )
      .trim()
      .toLowerCase()
      .includes("4-week");


    for (let i = 0; i < updatedWeeklyData.length; i++) {
      const row = updatedWeeklyData[i];
      const q = row.newFinalQuota;
      const consumption = row.consumption;
      const depletionModel = row?.depletionModel?.toLowerCase();

      if (depletionModel === "none") {
        if (q.weekly1 < consumption) {
          showMessage(
            "Quota value should not be less than Consumption value.",
            "error"
          );
          return false;
        }
      } else if (depletionModel === "biweekly") {
        if (q.weekly1 > q.weekly2) {
          showMessage(
            "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
            "error"
          );
          return false;
        }
        if (
          q.weekly2 < consumption ||
          (getWeekStatus.chkFirstHalf && q.weekly1 < consumption)
        ) {
          showMessage(
            "Quota value should not be less than Consumption value.",
            "error"
          );
          return false;
        }
      } else {
        if (getWeekStatus.chkWeek1) {
          const week1OrderInvalid = isFourWeekPeriod
            ? q.weekly2 < q.weekly1 ||
              q.weekly3 < q.weekly1 ||
              q.weekly4 < q.weekly1
            : q.weekly2 < q.weekly1 ||
              q.weekly3 < q.weekly1 ||
              q.weekly4 < q.weekly1 ||
              q.weekly5 < q.weekly1;
          if (week1OrderInvalid) {
            showMessage(
              "Quota value for weeks ahead of Week 1 should be greater than Week 1 value.",
              "error"
            );
            return false;
          }
        }
        if (getWeekStatus.chkWeek2) {
          const week2OrderInvalid = isFourWeekPeriod
            ? q.weekly3 < q.weekly2 || q.weekly4 < q.weekly2
            : q.weekly3 < q.weekly2 ||
              q.weekly4 < q.weekly2 ||
              q.weekly5 < q.weekly2;
          if (week2OrderInvalid) {
            showMessage(
              "Quota value for weeks ahead of Week 2 should be greater than Week 2 value.",
              "error"
            );
            return false;
          }
        }
        if (getWeekStatus.chkWeek3) {
          const week3OrderInvalid = isFourWeekPeriod
            ? q.weekly4 < q.weekly3
            : q.weekly4 < q.weekly3 || q.weekly5 < q.weekly3;
          if (week3OrderInvalid) {
            showMessage(
              "Quota value for weeks ahead of Week 3 should be greater than Week 3 value.",
              "error"
            );
            return false;
          }
        }
        if (getWeekStatus.chkWeek4 && !isFourWeekPeriod && q.weekly5 < q.weekly4) {
          showMessage(
            "Week 5 Quota should be greater than previous Week Quota.",
            "error"
          );
          return false;
        }
        const consumptionInvalid = isFourWeekPeriod
          ? (getWeekStatus.chkWeek1 && q.weekly1 < consumption) ||
            (getWeekStatus.chkWeek2 && q.weekly2 < consumption) ||
            (getWeekStatus.chkWeek3 && q.weekly3 < consumption) ||
            (getWeekStatus.chkWeek4 && q.weekly4 < consumption)
          : q.weekly5 < consumption ||
            (getWeekStatus.chkWeek4 && q.weekly4 < consumption) ||
            (getWeekStatus.chkWeek3 && q.weekly3 < consumption) ||
            (getWeekStatus.chkWeek2 && q.weekly2 < consumption) ||
            (getWeekStatus.chkWeek1 && q.weekly1 < consumption);
        if (consumptionInvalid) {
          showMessage(
            "Quota value should not be less than Consumption value.",
            "error"
          );
          return false;
        }
      }
    }
    return true;
  };
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  const handleOnCustomerProductChange = (selectCustomer, selectProduct) => {
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
    filteredRow();
  };

  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchCustomer]);

  useEffect(() => {
    handleOnCustomerProductChange(searchCustomer, searchProduct);
  }, [searchProduct]);

  useEffect(() => {
    if (isDisplayBlockedCustomers) {
      setIsOnlySelectedCustomers(false);
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          if (isDisplayBlockedCustomers !== undefined) {
            if (searchProduct === undefined) setSearchProduct("");
            if (searchCustomer === undefined) setSearchCustomer("");
            retVal = item.orderStatus.toLowerCase().includes("blocked") &&
              (item.customerName
                .toLowerCase()
                .includes(searchCustomer.toLowerCase()) ||
                item.sapCustomerNumber
                  .toLowerCase()
                  .includes(searchCustomer.toLowerCase())) &&
              (item.skuName
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()) ||
                item.skuNumb
                  .toLowerCase()
                  .includes(searchProduct?.toLowerCase()));
          } else {
            return retVal;
          }
          return retVal;
        });
        return val;
      });
    } else {
      setIsOnlySelectedCustomers(false);
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          retVal =
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
          return retVal;
        });
        return val;
      });
    }
    if (isModifyClicked) {
      scrollToThirdDataGrid();
    }
  }, [isDisplayBlockedCustomers]);
  useEffect(() => {
    setIsDisplayBlockedCustomers(isDisplayBlocked);
  }, [isDisplayBlocked])
  const handleIsOnlySelected = (e) => {
    setIsOnlySelectedCustomers(e.target.checked);
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
  };

  const filteredRow = (RowList) =>{
    if (isOnlySelectedCustomers) {
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;

          if (rowSelectionModel !== undefined) {
            retVal =
            rowSelectionModel.includes(item.customerQuotaID) &&
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
          } else {
            return retVal;
          }


          return retVal;
        });
        return val;
      });
    } else {
      setRows((prevVal) => {
        let val = ModifiedList?.quotaCusumptionCustomers?.filter((item) => {
          let retVal = false;
          retVal =
            (item.customerName
              .toLowerCase()
              .includes(searchCustomer.toLowerCase()) ||
              item.sapCustomerNumber
                .toLowerCase()
                .includes(searchCustomer.toLowerCase())) &&
            (item.skuName
              .toLowerCase()
              .includes(searchProduct?.toLowerCase()) ||
              item.skuNumb
                .toLowerCase()
                .includes(searchProduct?.toLowerCase()));
            return retVal;
        });
        return val;
      });
    }
  }
  useEffect(() => {
    if(searchProduct === undefined)setSearchProduct("");
    if(searchCustomer === undefined)setSearchCustomer("");
    filteredRow();
  }, [isOnlySelectedCustomers]);
  useEffect(() => {
    if (selectedWeeklyData.length > 0) {
      let result = selectedWeeklyData?.map((x) => x.customerQuotaID);
      setRowSelectionModel(result);
    }
  }, [selectedWeeklyData]);

  const weeklyUpdatedData = (obj) => {
    let resultObj = {
      customerComments: obj.customerComments,
      customerGroupID: obj.customerGroupID,
      customerID: obj.customerID,
      customerQuotaID: obj.customerQuotaID,
      orderStatus: obj.orderStatus,
      productGroupID: obj.productGroupID,
      skuid: obj.skuid,
      weekly1: parseInt(obj.newFinalQuota.weekly1),
      weekly2: parseInt(obj.newFinalQuota.weekly2),
      weekly3: parseInt(obj.newFinalQuota.weekly3),
      weekly4: parseInt(obj.newFinalQuota.weekly4),
      weekly5: parseInt(obj.newFinalQuota.weekly5),
    };

    return resultObj;
  };


  const getRowDepletionModel = (item) =>
    (item?.depletionModel ?? "").trim().toLowerCase();

  const canEditWeeklyFieldForRow = (item, weekNumber) => {
    const depletionModel = getRowDepletionModel(item);
    switch (weekNumber) {
      case 1:
        if (depletionModel === "none") return true;
        if (depletionModel === "biweekly") return getWeekStatus.chkFirstHalf;
        return getWeekStatus.chkWeek1;
      case 2:
        if (depletionModel === "none") return false;
        if (depletionModel === "biweekly") return true;
        return getWeekStatus.chkWeek2;
      case 3:
        if (depletionModel === "none" || depletionModel === "biweekly") {
          return false;
        }
        return getWeekStatus.chkWeek3;
      case 4:
        if (depletionModel === "none" || depletionModel === "biweekly") {
          return false;
        }
        return getWeekStatus.chkWeek4;
      case 5:
        if (depletionModel === "none" || depletionModel === "biweekly") {
          return false;
        }
        return getWeekStatus.chkWeek5;
      default:
        return false;
    }
  };

  const handleOverallModification = () => {
    dispatch(setState("isLoading", true));
    const timeout = setTimeout(() => {
      const currentState = _.cloneDeep(updatedWeeklyData);
      const weekKeys = ["weekly1", "weekly2", "weekly3", "weekly4", "weekly5"];
      const headerChecked = [
        isCheckedHeader.isCheckedWeekly1,
        isCheckedHeader.isCheckedWeekly2,
        isCheckedHeader.isCheckedWeekly3,
        isCheckedHeader.isCheckedWeekly4,
        isCheckedHeader.isCheckedWeekly5,
      ];

      weekKeys.forEach((weekKey, index) => {
        const weekNumber = index + 1;
        if (!headerChecked[index] || modificationPercentage === "") return;

        currentState.forEach((item) => {
          if (!rowSelectionModel.includes(item.customerQuotaID)) return;
          if (!canEditWeeklyFieldForRow(item, weekNumber)) return;

          const val = item.newFinalQuota[weekKey];
          item.newFinalQuota[weekKey] = Math.round(
            val + (val / 100) * parseInt(modificationPercentage)
          );
          item.deltaModification[weekKey] =
            item.newFinalQuota[weekKey] - item.lastApproved[weekKey];
        });
      });

      rowSelectionModel.forEach((id) => {
        getUpdatedRowIds(id);
      });

      dispatch(setState("updatedWeeklyData", currentState));
      dispatch(setState("isLoading", false));
    }, 1);
  };

  const handleRounder = () => {
    if (rounder != "" && rounder > 0) {
      dispatch(setState("isLoading", true));
      const timer = setTimeout(() => {
        const currentState = _.cloneDeep(updatedWeeklyData);
        const weekKeys = ["weekly1", "weekly2", "weekly3", "weekly4", "weekly5"];
        const headerChecked = [
          isCheckedHeader.isCheckedWeekly1,
          isCheckedHeader.isCheckedWeekly2,
          isCheckedHeader.isCheckedWeekly3,
          isCheckedHeader.isCheckedWeekly4,
          isCheckedHeader.isCheckedWeekly5,
        ];

        weekKeys.forEach((weekKey, index) => {
          const weekNumber = index + 1;
          if (!headerChecked[index] || rounder === "") return;

          currentState.forEach((item) => {
            if (!rowSelectionModel.includes(item.customerQuotaID)) return;
            if (!canEditWeeklyFieldForRow(item, weekNumber)) return;

            const val = item.newFinalQuota[weekKey];
            item.newFinalQuota[weekKey] =
              parseInt(rounder) * Math.round(val / parseInt(rounder));
            item.deltaModification[weekKey] =
              item.newFinalQuota[weekKey] - item.lastApproved[weekKey];
          });
        });

        rowSelectionModel.forEach((id) => {
          getUpdatedRowIds(id);
        });
        dispatch(setState("updatedWeeklyData", currentState));
        dispatch(setState("isLoading", false));
      }, 1);
    }
  };

  const pullForwardQuota = async () => {
    if (rowSelectionModel.length === 0) {
      showMessage("Please select customer", "error");
      return;
    }

    const isFourWeekPeriod = (
      ModifiedList?.depletionPeriodType ?? ModifiedList?.DepletionPeriodType ?? ""
    )
      .trim()
      .toLowerCase()
      .includes("4-week");

    const currentState = _.cloneDeep(updatedWeeklyData);
    currentState.forEach((item) => {
      if (!rowSelectionModel.includes(item.customerQuotaID)) return;

      const depletionModel = getRowDepletionModel(item);
      if (depletionModel === "none") return;

      if (depletionModel === "biweekly") {
        if (!canEditWeeklyFieldForRow(item, 1)) return;
        item.newFinalQuota.weekly1 = item.newFinalQuota.weekly2;
        item.deltaModification.weekly1 =
          item.newFinalQuota.weekly1 - item.lastApproved.weekly1;
        return;
      }

      const sourceWeekKey = isFourWeekPeriod ? "weekly4" : "weekly5";
      const sourceWeekValue = item.newFinalQuota[sourceWeekKey];

      [1, 2, 3, 4].forEach((weekNumber) => {
        if (!canEditWeeklyFieldForRow(item, weekNumber)) return;
        const weekKey = `weekly${weekNumber}`;
        item.newFinalQuota[weekKey] = sourceWeekValue;
        item.deltaModification[weekKey] =
          item.newFinalQuota[weekKey] - item.lastApproved[weekKey];
      });
    });

    rowSelectionModel.forEach((id) => {
      getUpdatedRowIds(id);
    });

    dispatch(setState("updatedWeeklyData", currentState));
  };

  //console.log(weeklyPullForward)

  useEffect(() => {
    if (selectedValues.length === 0) {
      setRows([]);
    } else {
      //setRows(quotaConsumptionTableState);
      filteredRow();
    }
    if (isModifyClicked) {
      scrollToThirdDataGrid();
    }
  }, [selectedValues]);

  //const visibleColumns = columns.filter((col) => !hideColumns(props.row.id).includes(col.field));
  const quotaCustomers = ModifiedList?.quotaCusumptionCustomers ?? [];
  const customerDepletionModels = quotaCustomers.map((customer) =>
    (customer?.depletionModel ?? customer?.DepletionModel ?? "")
      .trim()
      .toLowerCase()
  );
  const allNone =
    quotaCustomers.length > 0 &&
    customerDepletionModels.every((model) => model === "none");
  const allBiweekly =
    quotaCustomers.length > 0 &&
    customerDepletionModels.every((model) => model === "biweekly");

  let visibleColumns = [...columns];
  if (allNone) {
    visibleColumns = [...columns, ...noDepletionColumns];
  } else if (allBiweekly) {
    visibleColumns = [...columns, ...biweeklyColumns];
  } else {
    visibleColumns = [...columns, ...weeklyColumns];
  }

  const depletionPeriodType = (
    ModifiedList?.depletionPeriodType ?? ""
  )
    .trim()
    .toLowerCase();
  if (depletionPeriodType.includes("4-week")) {
    visibleColumns = visibleColumns.filter((col) => col.field !== "weekly5");
  }

  const isWeeklyPeriodType =
    (ModifiedList?.periodType ?? ModifiedList?.PeriodType ?? "")
      .trim()
      .toLowerCase() === "weekly";
  if (isWeeklyPeriodType) {
    visibleColumns = visibleColumns.filter(
      (col) => col.field !== "depletionModelName"
    );
  }

  const selectedScenarioRow = getScenarios?.find(
    (row) =>
      String(row.scenarioID) === String(selectedScenarioID) &&
      String(row.quotaID) === String(selectedQuotaID)
  );
  const scenarioDepletionModelName =
    selectedScenarioRow?.depletionModelName ??
    selectedScenarioRow?.DepletionModelName ??
    "";
  const scenarioDepletionPeriodType =
    selectedScenarioRow?.depletionPeriodType ??
    selectedScenarioRow?.DepletionPeriodType ??
    ModifiedList?.depletionPeriodType ??
    ModifiedList?.DepletionPeriodType ??
    "";

  const getRowQuotaWeekValue = (row, quotaKey) => {
    const quota = row?.[quotaKey];
    if (!quota) return 0;
    const rowDepletionModel = (row?.depletionModel ?? row?.DepletionModel ?? "")
      .trim()
      .toLowerCase();
    if (rowDepletionModel === "none") return quota.weekly1 ?? 0;
    if (rowDepletionModel === "biweekly") return quota.weekly2 ?? 0;
    if (depletionPeriodType.includes("4-week")) return quota.weekly4 ?? 0;
    return quota.weekly5 ?? 0;
  };

  let getTotalQuotaCM = updatedWeeklyData?.reduce(
    (acc, obj) => acc + obj.quota,
    0
  );
  let modifiedQuotaCM =
    updatedWeeklyData?.reduce(
      (acc, obj) => acc + getRowQuotaWeekValue(obj, "newFinalQuota"),
      0
    ) ?? 0;
  let differenceCM =
    modifiedQuotaCM - getTotalQuotaCM < 0
      ? getTotalQuotaCM - modifiedQuotaCM
      : modifiedQuotaCM - getTotalQuotaCM;
  let differenceCMPerc = getTotalQuotaCM === 0? 0 :(differenceCM / getTotalQuotaCM) * 100;
  differenceCMPerc = differenceCMPerc.toFixed(0);
  let getTotalQuotaAQ =
    updatedWeeklyData?.reduce(
      (acc, obj) => acc + getRowQuotaWeekValue(obj, "initialQuota"),
      0
    ) ?? 0;
  let modifiedQuotaAQ =
    updatedWeeklyData?.reduce(
      (acc, obj) => acc + getRowQuotaWeekValue(obj, "newFinalQuota"),
      0
    ) ?? 0;
  let differenceAQ =
    modifiedQuotaAQ - getTotalQuotaAQ < 0
      ? getTotalQuotaAQ - modifiedQuotaAQ
      : modifiedQuotaAQ - getTotalQuotaAQ;
  let differenceAQPerc = getTotalQuotaAQ === 0 ? 0 :(differenceAQ / getTotalQuotaAQ) * 100;
  differenceAQPerc = differenceAQPerc.toFixed(0);

  const handleExportFile = () => {
    const filteredCustomers = updatedWeeklyData.map((item) => ({
      customerName: item.customerName,
      sapCustomerNumber: item.sapCustomerNumber,
      skuName: item.skuName,
      skuNumb: item.skuNumb,
      customerGroupID: item.customerGroupID,
      customerQuotaID: item.customerQuotaID,
      depletionModel: item.depletionModel ?? item.DepletionModel,
      depletionModelName: item.depletionModelName ?? item.DepletionModelName,
      newFinalQuota: item.newFinalQuota,
    }));

    const exportDepletionModel = allRowsNoneDepletion
      ? "none"
      : allRowsBiweeklyDepletion
        ? "biweekly"
        : "weekly";

    let quotaConsumptionScenario = {};
    quotaConsumptionScenario.countryName = selectedCountry;
    quotaConsumptionScenario.countryid = selectedCountryID;
    quotaConsumptionScenario.depletionModel = exportDepletionModel;
    quotaConsumptionScenario.depletionPeriodType =
      ModifiedList?.depletionPeriodType ?? ModifiedList?.DepletionPeriodType;
    quotaConsumptionScenario.periodType =
      ModifiedList?.periodType ?? ModifiedList?.PeriodType;
    quotaConsumptionScenario.quotaCusumptionCustomers = filteredCustomers;
    quotaConsumptionScenario.scenarioID = selectedScenarioID;
    quotaConsumptionScenario.scenarioName = selectedScenario;

    let obj = {
      period: selectedPeriod === 0 ? "Previous" : "Current",
      quotaConsumptionScenario: quotaConsumptionScenario,
      weeks: getWeekStatus,
    };

    dispatch(ExportExcel(obj));
  };

  const handleSelectFile = (file) => {
    setUploadedFile(file);
  };

  const handleDelete = () => {
    setUploadedFile(null);
  };

  const handleImportFile = () => {
    const formData = new FormData();
    formData.append("files", uploadedFile, uploadedFile.name);
    formData.append("country", selectedCountry);
    formData.append("scenario", selectedScenario);
    formData.append("weeklyDepletion", ModifiedList?.depletionModel);
    // let obj = {
    //   scenarioName: selectedScenario,
    //   countryName: selectedCountry,
    //   depletion: ModifiedList?.depletionModel,
    //   formData: formData,
    // };
    dispatch(ImportExcel(formData));
    setUploadedFile(null);
  };

  useEffect(() => {
    if (!excelData?.quotaCusumptionCustomers) return;
    let currentState = _.cloneDeep(updatedWeeklyData);
    const currentStateMap = new Map(
      updatedWeeklyData.map((obj) => [obj.customerQuotaID, obj])
    );
    const updatedCustomerQuota = [];
    const updatedCustomerQuotaIds = [];

    const hasImportableChanges = (row, excelRow) => {
      const weekChanges = [
        row.lastApproved.weekly1 !== excelRow.weekly1,
        row.lastApproved.weekly2 !== excelRow.weekly2,
        row.lastApproved.weekly3 !== excelRow.weekly3,
        row.lastApproved.weekly4 !== excelRow.weekly4,
        row.lastApproved.weekly5 !== excelRow.weekly5,
      ];
      if (row.customerComments !== excelRow.customerComments) {
        return true;
      }
      return weekChanges.some(
        (changed, index) => changed && canEditWeeklyFieldForRow(row, index + 1)
      );
    };

    excelData.quotaCusumptionCustomers.forEach((excelRow) => {
      const row = currentStateMap.get(excelRow.customerQuotaID);
      if (!row) return;

      if (hasImportableChanges(row, excelRow)) {
        updatedCustomerQuota.push(excelRow);
        updatedCustomerQuotaIds.push(excelRow.customerQuotaID);
      }
    });

    const weekImportFields = [
      { quotaKey: "weekly1", excelKey: "weekly1", weekNumber: 1 },
      { quotaKey: "weekly2", excelKey: "weekly2", weekNumber: 2 },
      { quotaKey: "weekly3", excelKey: "weekly3", weekNumber: 3 },
      { quotaKey: "weekly4", excelKey: "weekly4", weekNumber: 4 },
      { quotaKey: "weekly5", excelKey: "weekly5", weekNumber: 5 },
    ];

    currentState?.forEach((item) => {
      if (!updatedCustomerQuotaIds.includes(item.customerQuotaID)) return;

      const excelRow = updatedCustomerQuota.find(
        (o) => o.customerQuotaID === item.customerQuotaID
      );
      if (!excelRow) return;

      weekImportFields.forEach(({ quotaKey, excelKey, weekNumber }) => {
        if (!canEditWeeklyFieldForRow(item, weekNumber)) return;

        item.newFinalQuota[quotaKey] = excelRow[excelKey];
        item.deltaModification[quotaKey] =
          item.newFinalQuota[quotaKey] - item.lastApproved[quotaKey];
      });

      item.customerComments = excelRow.customerComments;
    });

    dispatch(setState("updatedWeeklyData", currentState));
    let updatedList = {
      ...ModifiedList,
      quotaCusumptionCustomers: currentState,
    };
    dispatch(setState("ModifiedList", updatedList));
    setExcelCustomerIds(updatedCustomerQuotaIds);
    let updatedComments = { ...userComments };
    currentState?.forEach((item) => {
      if (updatedCustomerQuotaIds.includes(item.customerQuotaID)) {
        updatedComments = {
          ...updatedComments,
          [item.customerQuotaID]: item.customerComments,
        };
      }
    });
    setUserComments(updatedComments);
  }, [excelData]);

  useEffect(() => {
    if (excelCustomerIds.length > 0) {
      setRowSelectionModel(excelCustomerIds);
      excelCustomerIds.forEach((id) => {
        getUpdatedRowIds(id);
      });
    }
  }, [excelCustomerIds]);

  const handleDownloadFile = (filepath) => {
    console.log("handleDownloadFile");
    dispatch(DownloadFile(filepath));
  };
  function handleInputClick() {
    inputRef.current.click();
  }

  function uploadFile(event) {
    const file = event.target.files[0];
    const obj = event.target.files[0];
    //console.log(file);
    let idx = files.findIndex((f) => f.name === file.name);
		if(idx > -1) {
			showMessage("File already attached", "info");
			return;
		}
    dispatch(addFile(obj));
  }
  useEffect(()=>{
		resetFileInput();
	},[files]);

  // Console stmt by Amrutha
  useEffect(()=>{
    console.log("displayModification",displayModification);
    console.log("The canModifyRecall",canModifyRecall);
  },[]);

  const resetFileInput = () => { inputRef.current.value = ''; };

  function handleDeleteFile(file) {
    //console.log(file);
    dispatch(deleteFile(file));
  }
  function handleDeleteFileExisting(file) {
    console.log(file);
    dispatch(deleteExistingFile(file));
 }
  function handleDownloadFileUploaded(file) {
    console.log("handleDownloadFileUploaded");
		const url = URL.createObjectURL(file); 
		const link = document.createElement('a'); 
		link.href = url; 
		link.setAttribute('download', file.name); 
		document.body.appendChild(link); 
		link.click(); 
		link.parentNode.removeChild(link); 
		URL.revokeObjectURL(url);
	}
  const isRowQuotaInvalid = (row) => {
    const isFourWeekPeriod = (
      ModifiedList?.depletionPeriodType ?? ""
    ).trim().toLowerCase().includes("4-week");

    const q = row.newFinalQuota;
    const consumption = row.consumption;
    const depletionModel = (row?.depletionModel ?? "").trim().toLowerCase();

    if (depletionModel === "none") {
      return q.weekly1 < consumption;
    }
    if (depletionModel === "biweekly") {
      if (q.weekly1 > q.weekly2) return true;
      return (
        q.weekly2 < consumption ||
        (getWeekStatus.chkFirstHalf && q.weekly1 < consumption)
      );
    }
    if (getWeekStatus.chkWeek1) {
      const week1OrderInvalid = isFourWeekPeriod
        ? q.weekly2 < q.weekly1 || q.weekly3 < q.weekly1 || q.weekly4 < q.weekly1
        : q.weekly2 < q.weekly1 ||
          q.weekly3 < q.weekly1 ||
          q.weekly4 < q.weekly1 ||
          q.weekly5 < q.weekly1;
      if (week1OrderInvalid) return true;
    }
    if (getWeekStatus.chkWeek2) {
      const week2OrderInvalid = isFourWeekPeriod
        ? q.weekly3 < q.weekly2 || q.weekly4 < q.weekly2
        : q.weekly3 < q.weekly2 ||
          q.weekly4 < q.weekly2 ||
          q.weekly5 < q.weekly2;
      if (week2OrderInvalid) return true;
    }
    if (getWeekStatus.chkWeek3) {
      const week3OrderInvalid = isFourWeekPeriod
        ? q.weekly4 < q.weekly3
        : q.weekly4 < q.weekly3 || q.weekly5 < q.weekly3;
      if (week3OrderInvalid) return true;
    }
    if (getWeekStatus.chkWeek4 && !isFourWeekPeriod && q.weekly5 < q.weekly4) {
      return true;
    }
    return isFourWeekPeriod
      ? (getWeekStatus.chkWeek1 && q.weekly1 < consumption) ||
          (getWeekStatus.chkWeek2 && q.weekly2 < consumption) ||
          (getWeekStatus.chkWeek3 && q.weekly3 < consumption) ||
          (getWeekStatus.chkWeek4 && q.weekly4 < consumption)
      : q.weekly5 < consumption ||
          (getWeekStatus.chkWeek4 && q.weekly4 < consumption) ||
          (getWeekStatus.chkWeek3 && q.weekly3 < consumption) ||
          (getWeekStatus.chkWeek2 && q.weekly2 < consumption) ||
          (getWeekStatus.chkWeek1 && q.weekly1 < consumption);
  };

  const getRowClassName = (params) => {
    if (updatedWeeklyData?.length === 0) return "";
    const row = updatedWeeklyData.find(
      (o) => o.customerQuotaID === params.row.customerQuotaID
    );
    if (row && isRowQuotaInvalid(row)) {
      return "lightred-row";
    }
    return params.row.isModified ? "modified-row" : "";
  };
  const handleRecallModification = () => {
    dispatch(setState("isModifyClicked", true));
    dispatch(setState("isRecallClicked", true));
    dispatch(RecallModification(getQuotaDetails?.quotaID)).then(() => {
      dispatch(setState("displayModification", true));
      dispatch(setState("canModifyRecall",false));
      //setIsModificationOpened(true);
    });
  };
  useEffect(() => {
    if (isRecallClicked) {
      if (RecallList.length > 0) {
        handleRetrive(true, [], false);
      }
    }
  }, [RecallList]);

  const handleRetrive = (isRecall, customerList, isFullOrder) => {
    dispatch(setState("isModifyClicked", true));
    if (isRecall) {
      if (getQuotaDetails?.quotaCusumptionCustomers?.length > 0) {
        let getRecallModList = JSON.parse(JSON.stringify(getQuotaDetails));
        let consumptionList = getRecallModList?.quotaCusumptionCustomers;
        if (consumptionList?.length > 0) {
          for (let i = 0; i < RecallList?.length; i++) {
            let index = consumptionList.findIndex(
              (x) => x.customerQuotaID === RecallList[i]?.customerQuotaID
            );
            if (index !== -1) {
              consumptionList[index].newFinalQuota.weekly1 =
                RecallList[i]?.weekly1;
              consumptionList[index].newFinalQuota.weekly2 =
                RecallList[i]?.weekly2;
              consumptionList[index].newFinalQuota.weekly3 =
                RecallList[i]?.weekly3;
              consumptionList[index].newFinalQuota.weekly4 =
                RecallList[i]?.weekly4;
              consumptionList[index].newFinalQuota.weekly5 =
                RecallList[i]?.weekly5;
              consumptionList[index].deltaModification.weekly1 = 
              consumptionList[index].newFinalQuota.weekly1 - consumptionList[index].lastApproved.weekly1;
              consumptionList[index].deltaModification.weekly2 = 
              consumptionList[index].newFinalQuota.weekly2 - consumptionList[index].lastApproved.weekly2;
              consumptionList[index].deltaModification.weekly3 = 
              consumptionList[index].newFinalQuota.weekly3 - consumptionList[index].lastApproved.weekly3;
              consumptionList[index].deltaModification.weekly4 = 
              consumptionList[index].newFinalQuota.weekly4 - consumptionList[index].lastApproved.weekly4;
              consumptionList[index].deltaModification.weekly5 = 
              consumptionList[index].newFinalQuota.weekly5 - consumptionList[index].lastApproved.weekly5;
              consumptionList[index].newFinalQuota.customerComments =
                RecallList[i]?.customerComments;
            }
          }
        }
        getRecallModList.quotaCusumptionCustomers = consumptionList;
        dispatch(setState("ModifiedList", getRecallModList));
        dispatch(
          setState(
            "updatedWeeklyData",
            getRecallModList?.quotaCusumptionCustomers
          )
        );
          dispatch(
            setState("modifyList", getRecallModList?.quotaCusumptionCustomers)
          );
          dispatch(setState("CustomerSearchTxt", ""));
          dispatch(setState("ProductSearchTxt", ""));
          //dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
      }
      dispatch(setState("isRecallClicked", false));
    } 
    else {
      dispatch(setState("ModifiedList", getQuotaDetails));
      dispatch(
        setState("updatedWeeklyData", getQuotaDetails?.quotaCusumptionCustomers)
      );
        dispatch(
          setState("modifyList", getQuotaDetails?.quotaCusumptionCustomers)
        );
        dispatch(setState("CustomerSearchTxt", ""));
        dispatch(setState("ProductSearchTxt", ""));
        //dispatch(setState("isDisplayBlocked", isDisplayBlockedCustomers));
    }
    dispatch(setState("displayModification", true));
    //setIsModificationOpened(true);
  };



  return (
    <div>
      <Box m={2}>
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        {/* <Box className="scenario-search"> */}
        {/* <Grid container columns={12} justifyContent="space-between" alignItems="center" spacing={2} pb={1}>

                </Grid> */}

        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>

        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid
            item
            container
            direction="column"
            xs={12}
            sm={3.1}
            md={3.1}
            lg={3.1}
            spacing={2}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="subtitle1" my={2}>
                Scenario of : {selectedScenario}
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={1}>
                <b>Period Structure: </b> {scenarioDepletionPeriodType || "-"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <b>Time Depletion: </b> {scenarioDepletionModelName || "-"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Search Customer"
                value={searchCustomer}
                onChange={handleSearchCustomer}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
                fullWidth
                size="small"
              ></TextField>
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                label="Search Product"
                value={searchProduct}
                onKeyDown={(e) => {
                  if (e.key !== "Escape") {
                    // Prevents autoselecting item while typing (default Select behaviour)
                    e.stopPropagation();
                  }
                }}
                onChange={handleSearchProduct}
                fullWidth
                size="small"
              ></TextField>
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sm={8.8}
            md={8.8}
            lg={8.8}
            sx={{ mt: 1.5 }}
          >
            <Grid item xs={12} md={12} lg={12}>
              <Box ref={ModRef}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow
                        sx={{
                          "& th": {
                            //color: "#007DC3",
                            backgroundColor: "#fcfcfe",
                          },
                        }}
                      >
                        <TableCell></TableCell>
                        <TableCell align="center">
                          <strong>Total Quota</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>Total Mod. Quota</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>Absolute Difference</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>% Difference</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {/* {rows.map((row) => ( */}
                      <TableRow
                        key={"LQuota"}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {"Changed vs Last Modified Quota"}
                        </TableCell>
                        <TableCell align="center">{getTotalQuotaCM?.toLocaleString('en-US')}</TableCell>
                        <TableCell align="center">{modifiedQuotaCM?.toLocaleString('en-US')}</TableCell>
                        <TableCell align="center">{differenceCM?.toLocaleString('en-US')}</TableCell>
                        <TableCell align="center">{differenceCMPerc}</TableCell>
                      </TableRow>

                      <TableRow
                        key={"LModQuota"}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {"Changed vs 1st Approved Quota"}
                        </TableCell>
                        <TableCell align="center">{getTotalQuotaAQ?.toLocaleString('en-US')}</TableCell>
                        <TableCell align="center">{modifiedQuotaAQ?.toLocaleString('en-US')}</TableCell>
                        <TableCell align="center">{differenceAQ?.toLocaleString('en-US')}</TableCell>
                        <TableCell align="center">{differenceAQPerc}</TableCell>
                      </TableRow>
                      {/* ))} */}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box mt={-1}>
        <Grid container columns={12} justifyContent="space-between" pl={2}>
          <Grid item xs={12} md={3} lg={3}>
            <Box display="flex" alignItems="center" mb={2}>
              <TextField
                //sx={{ width: 100, height: 45, border: 1, borderRadius: 1 }}\
                value={modificationPercentage}
                type={"number"}
                onChange={(e) => setModificationPercentage(e.target.value)}
                disableUnderline={true}
                autoFocus={false}
                variant="outlined"
                label={"% Modification"}
                size="small"
                fullWidth
                sx={{ mr: 3 }}
              ></TextField>
              <Button
                //startIcon={<CheckRoundedIcon />}
                style={{
                  width: "90px",
                  height: "45px",
                  borderRadius: "4px",
                  textTransform: "none",
                  marginTop: 1,
                }}
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkred.main",
                  },
                  minWidth: "56px !important",
                }}
                // onClick={() => modPercFunc.current()}
                onClick={handleOverallModification}
              >
                Apply
              </Button>
            </Box>
            <Box display="flex" alignItems="center">
              <TextField
                //sx={{ width: 100, height: 45, border: 1, borderRadius: 1 }}
                value={rounder}
                type={"number"}
                disableUnderline={true}
                autoFocus={false}
                label={"Rounder"}
                variant="outlined"
                onChange={(e) => setRounder(e.target.value)}
                size="small"
                fullWidth
                sx={{ mr: 3 }}
              ></TextField>
              <Button
                //startIcon={<CheckRoundedIcon />}
                style={{
                  width: "90px",
                  height: "45px",
                  borderRadius: "4px",
                  textTransform: "none",
                  marginTop: 3,
                }}
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkred.main",
                  },
                  minWidth: "56px !important",
                }}
                //onClick={() => rounderFunc.current()}
                onClick={handleRounder}
              >
                Apply
              </Button>
            </Box>
          </Grid>

          {/* <Grid item xs={12} md={6} lg={6} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <FormControlLabel
              sx={{mb: 6}}
              label="Only Selected Customers"
              control={
                <Checkbox
                  checked={isOnlySelectedCustomers}
                  onChange={handleIsOnlySelected}
                />
              }
            />
          </Grid> */}

          <Grid item xs={12} md={2} lg={2} sx={{ display: "flex", justifyContent: "flex-end", mr: 2 }}>
            <Button
              //startIcon={<ArrowDownwardRoundedIcon/>}
              disabled={allNone}
              style={{
                width: "200px",
                height: "45px",
                background: "#ECEFFF",
                color: "#001489",
                borderRadius: "4px",
                textTransform: "none",
                marginTop: 3,
              }}
              onClick={pullForwardQuota}
            >
              <strong>Pull forward Quota</strong>
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box m={2} mt={4}>
        <FormControl>
          <InputLabel sx={{ backgroundColor: "#fff", px: 1 }} id="select-label">
            Select Values
          </InputLabel>
          <Select
            labelId="select-label"
            id="select"
            multiple
            fullWidth
            value={selectedValues}
            onChange={handleSelectChange}
            renderValue={(selected) => (
              <div>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    onDelete={() => { }}
                    deleteIcon={
                      <ClearIcon onMouseDown={handleSelectDelete(value)} />
                    }
                  />
                ))}
              </div>
            )}
          >
            {selectInitialValues?.map((value) => (
              <MenuItem key={value} value={value}>
                <Checkbox checked={selectedValues.includes(value)} />
                {value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {displayModification && (

        <DataGrid
          sx={{
            fontFamily: "Montserrat, Sans-serif",
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              fontWeight: "bold !important",
              fontSize: "14px",
              fontFamily: "Montserrat, Sans-serif",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: "normal",
              fontWeight: "bold",
              fontSize: "14px",
              fontFamily: "Montserrat, Sans-serif",
            },
            "& .MuiDataGrid-columnHeader": {
              // Forced to use !important since overriding inline styles
              height: "unset !important",
            },
            "& .MuiDataGrid-columnHeaders": {
              // Forced to use !important since overriding inline styles
              maxHeight: "168px !important",
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "none !important",
            },
            "& .Mui-selected": {
              backgroundColor: "none !important",
            },
          }}
          //style={{ maxHeight: "70vh" }}
          apiRef={apiRef}
          rows={rows || []}
          columns={visibleColumns}
          getRowId={(row) => row?.customerQuotaID}
          rowKey={(row) => row?.customerQuotaID}
          //sx={{ width: '98%' }}
          rowHeight={rowHeight}
          // autoHeight = {true}
          pageSizeOptions={[20, 50, 100]}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          checkboxSelection={true}
          disableRowSelectionOnClick
          disableColumnMenu
          onRowSelectionModelChange={(newRowSelectionModel) => {
            //console.log(newRowSelectionModel);
            // let updatedRow = [
            //   ...new Set([...rowSelectionModel, ...newRowSelectionModel]),
            // ];
            setRowSelectionModel(newRowSelectionModel);
          }}
          rowSelectionModel={rowSelectionModel}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
          getRowClassName={getRowClassName}
          headerHeight={40}
          disableVirtualization={true}

        //rowBuffer = {8}
        //rowBufferPx = {100}
        //rowSelectionModel={rowSelectionModel.length > 0 ? rowSelectionModel : checkedCustomersList}
        />
      )}

  <CollapseSection title="Attachments">
  <Box sx={{ mt: 2 }}>
    {/* Existing Files */}
    <Table>
      <TableBody>
        {ModifiedList?.quotaModificationFiles?.map((row) => (
          <TableRow className="tableRow" key={row?._id}>
            <TableCell className="tableCell" sx={{ flexGrow: 1, ml: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar sx={{ bgcolor: "darkred.light" }}>
                  <InsertDriveFileIcon />
                </Avatar>
                <Box sx={{ ml: 2 }}>{row.filePath}</Box>
              </Box>
            </TableCell>
            <TableCell className="tableCell" width={"5%"}>
              <IconButton
                edge="start"
                aria-label="download"
                onClick={() => handleDownloadFile(row.filePath)}
              >
                <DownloadRoundedIcon />
              </IconButton>
            </TableCell>
            <TableCell className="tableCell" width={"5%"}>
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => handleDeleteFileExisting(row)}
                sx={{ mr: 0 }}
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>

    {/* Attach File Button */}
    <Box sx={{ display: "flex", justifyContent: "flex-end", my: 2 }}>
      <input hidden type="file" ref={inputRef} onChange={uploadFile} />
      <Button
        sx={{
          bgcolor: "darkred.light",
          color: "white.main",
          fontWeight: "700",
          "&:hover": { bgcolor: "darkred.main" },
        }}
        startIcon={<AttachmentIcon />}
        disabled={!isRestrictedAccess}
        onClick={handleInputClick}
      >
        Attach File
      </Button>
    </Box>

    {/* Newly Added Files */}
    <Table>
      <TableBody>
        {files?.map((file, index) => (
          <TableRow key={index} className="tableRow">
            <TableCell className="tableCell" sx={{ flexGrow: 1, ml: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar sx={{ bgcolor: "darkred.light" }}>
                  <InsertDriveFileIcon />
                </Avatar>
                <Box sx={{ ml: 2, fontWeight: "normal" }}>{file.name}</Box>
              </Box>
            </TableCell>
            <TableCell className="tableCell" width={"5%"}>
              <IconButton
                edge="start"
                aria-label="download"
                onClick={() => handleDownloadFileUploaded(file)}
              >
                <DownloadRoundedIcon />
              </IconButton>
            </TableCell>
            <TableCell className="tableCell" width={"5%"}>
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => handleDeleteFile(file)}
                sx={{ mr: 0 }}
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
</CollapseSection>
      <CollapseSection title="Comments">
      <Box sx={{ mt: 1 }}>
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          sx={{ mt: 2, mb: 1 }}
        >
        </Stack>
        <TextField
          className={"fullWidth"}
          size="large"
          multiline
          rows={6}
          onChange={(event) => setMainComments(event.target.value)}
          aria-label="minimum height"
          //placeholder="Comments"
          style={{ width: "100%", overflowY: "auto" }}
          defaultValue={ModifiedList?.comments}
        />
      </Box>
      </CollapseSection>
      <Box mt={3}>
        <Grid container columns={12} justifyContent="flex-end" spacing={3}>
          {!canModifyRecall && (
            <Grid item xs={6} sm={6} md={1.5} lg={1.5}>
            <Button
              //startIcon={<LabelImportantRoundedIcon />}
              sx={{ height: 45,
                }}
              id="SearchButton"
              disabled={!isRestrictedAccess}
              style={{
                background: "#ECEFFF",
                color: "#001489",
                borderRadius: "4px",
                textTransform: "none",
              }}
              fullWidth
              onClick={handleChooseFile}
            >
              Choose File
            </Button>
          </Grid>
          )}
          {!canModifyRecall && (
          <Grid item xs={6} sm={6} md={2} lg={2}>
          <Button
            //startIcon={<LabelImportantRoundedIcon />}
            variant="contained"
            id="SearchButton"
            disabled={!isRestrictedAccess}
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              fontWeight: "700",
              textTransform: "none",
              "&:hover": {
                bgcolor: "darkred.main",
              },
              height: 45, mb: 3,
              borderRadius: "4px",
            }}
            fullWidth
            onClick={handleSubmit}
          >
            Submit Modification
          </Button>
        </Grid>
        )}

          {canModifyRecall && (
              <Grid item xs={6} sm={6} md={2} lg={2}>
                <Button
                  startIcon={<EditIcon />}
                  variant="contained"
                  sx={{
                    bgcolor: "darkred.light",
                    color: "white.main",
                    fontWeight: "700",
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: "darkred.main",
                    },
                    height: 45,
                    mb: 3,
                    borderRadius: "4px",
                  }}
                  fullWidth
                  onClick={handleRecallModification} 
                >
                  Recall Modification
                </Button>
              </Grid>
            )}
        </Grid>

        {displayFileButtons && (
            <Grid ref={fileSectionRef}>
            <CollapseSection title="Choose File">
              <Grid
                container
                columns={12}
                justifyContent="flex-end"
                spacing={2}
                mt={2}
              >
                <Grid item xs={6} sm={1.5} md={1.5} lg={1.4}>
                  <Button
                    //startIcon={<LabelImportantRoundedIcon />}
                    id="SearchButton"
                    sx={{
                      bgcolor: "darkred.light",
                      color: "white.main",
                      fontWeight: "700",
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: "darkred.main",
                      },
                      height: 45, mb: 3,
                      width: "100%",
                      borderRadius: "4px",
                    }}
                    fullWidth
                    onClick={() => hiddenFileInput.current.click()}
                  >
                    <input
                      type="file"
                      accept=".xlsx"
                      ref={hiddenFileInput}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        handleSelectFile(file);
                      }}
                      style={{ display: "none", marginLeft: "100%" }}
                      id="fileInput"
                      onclick="fileInput.value = null"
                      value=""
                    />
                    Select File
                  </Button>
                </Grid>
                {uploadedFile && (
                  <Grid item xs={6} sm={1.5} md={1.5} lg={1.4}>
                    <Button
                      //startIcon={<LabelImportantRoundedIcon />}
                      id="SearchButton"
                      sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        fontWeight: "700",
                        textTransform: "none",
                        "&:hover": {
                          bgcolor: "darkred.main",
                        },
                        height: 45,
                        width: "100%",
                        borderRadius: "4px",
                      }}
                      fullWidth
                      onClick={handleImportFile}
                    >
                      Import
                    </Button>
                  </Grid>
                )}

                <Grid item xs={6} sm={1.5} md={1.5} lg={1.4}>
                  <Button
                    //startIcon={<LabelImportantRoundedIcon />}
                    id="SearchButton"
                    sx={{
                      bgcolor: "darkred.light",
                      color: "white.main",
                      fontWeight: "700",
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: "darkred.main",
                      },
                      height: 45,
                      width: "100%",
                      borderRadius: "4px",
                    }}
                    fullWidth
                    onClick={handleExportFile}
                  >
                    Export File
                  </Button>
                </Grid>
              </Grid>
              <Box sx={{ mt: 1 , display: 'flex', justifyContent: "flex-end"}}>
                {uploadedFile && (
                  <div className="file-display">
                    <span>{uploadedFile.name}</span>
                    <Button
                      sx={{
                        color: "darkred.light"
                      }}
                      onClick={handleDelete}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                )}
              </Box>
            </CollapseSection>
          </Grid>
        )}
      </Box>
    </div>
  );
};

export default Modification;
